import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { DOCUMENT } from '@angular/common';
import { ERRO_ENTRADA_TRATADO, chamadaEntrada } from '../../acesso/acesso-http';

/** O chamador assume a apresentação do erro (sem alerta global). */
export const ERRO_TRATADO_NO_COMPONENTE = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);
  const origem = inject(DOCUMENT).location.origin;
  if (req.method === 'POST' && req.context.get(ERRO_ENTRADA_TRATADO) && chamadaEntrada(req.url, origem)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.context.get(ERRO_TRATADO_NO_COMPONENTE)) {
        return throwError(() => error);
      }
      if (error.status === 400 && (error.error?.errorCode === 'CADASTRO_MATRICULA_EXISTENTE' || error.error?.errorCode === 'ITEM_EM_USO')) {
        return throwError(() => error);
      }
      // Preço do serviço especial: o componente exibe "Valor inválido!" no 400 de validação
      if (error.status === 400 && req.method === 'PATCH' && /\/itens-especiais\/\d+\/preco$/.test(req.url)) {
        return throwError(() => error);
      }
      let message = 'Erro inesperado';

      if (error.error?.errors && error.error.errors.length > 0) {
        alertService.errorList(error.error.errors);
      } else {
        if (error.error?.message || error.error?.detail) {
          message = error.error.message || error.error.detail;
        } else if (error.status === 0) {
          message = 'Erro de conexão com o servidor';
        } else if (error.status >= 500) {
          message = 'Erro interno no servidor';
        } else if (error.status === 401) {
          message = 'Não autorizado';
        } else if (error.status === 403) {
          message = 'Você não tem permissão para essa ação';
        } else if (error.status === 404) {
          message = 'Registro não encontrado';
        }
        alertService.error(message);
      }

      return throwError(() => error);
    })
  );
};
